export default __webpack_public_path__ + "static/media/Play-Bold.543d6025.ttf";